
ixModuleRouting('impactx.productcomparison',  {
    '/productcomparison': {
        templateUrl: 'modules/productcomparison/productcomparison.html',
        controller: 'ProductComparisonCtrl',
        process: 'CompareProducts',
        workspace: 'shop'
    }
},['ngRoute', 'impactx.basketLink'])
    .service('ProductComparisonHelperService', function() {

        function createDummyAttributes(names) {
            var idx,
                result = [];

            for(idx = 0; idx < names.length; idx++) {
                result.push({
                    name: '',
                    value: ''
                });
            }
            return result;
        }

        function unifyAttributes(oldAttributes, allAttributeNames, enableNameCopy) {
            var idx,
                oldIdx,
                attrName,
                oldAttributeNames = [],
                resultAttributes = [];

            for(idx = 0; idx < oldAttributes.length; idx++) {
                oldAttributeNames.push(oldAttributes[idx].name);
            }

            for(idx = 0; idx < allAttributeNames.length; idx++) {
                attrName = allAttributeNames[idx];
                oldIdx = oldAttributeNames.indexOf(attrName);

                if(oldIdx < 0) {
                    resultAttributes.push({
                        name: (enableNameCopy ? attrName : ''),
                        value: '',
                        isdummy: true
                    });
                }
                else {
                    //copy old
                    resultAttributes.push(oldAttributes[oldIdx]);
                }
            }

            return resultAttributes;
        }

        this.createDummyAttributes = createDummyAttributes;

        /**
         * Collects all attribute names from given list of products.
         * @param products
         * @return {Array}
         */
        this.collectAttributeNames = function(products) {
            var prodIdx,
                setIdx,
                attrIdx,
                collectedAttributeNames = [];
            if(products && products.length) {
                for(prodIdx = 0; prodIdx < products.length; prodIdx++) {
                    if (products[prodIdx].attributeSets) {
                        for(setIdx = 0; setIdx < products[prodIdx].attributeSets.length; setIdx++) {
                            for(attrIdx = 0; attrIdx < products[prodIdx].attributeSets[setIdx].attributes.length; attrIdx++) {
                                if(jQuery.inArray(products[prodIdx].attributeSets[setIdx].attributes[attrIdx].name, collectedAttributeNames) < 0) {
                                    collectedAttributeNames.push(products[prodIdx].attributeSets[setIdx].attributes[attrIdx].name);
                                }
                            }
                        }
                    }
                }
            }
            return collectedAttributeNames;
        };

        this.createDummyProduct = function(trns, allAttributeSetNames, allAttributeSetAttributeNames, copyNames) {
            var attributeList,
                idx,
                attrIdx,
                attributeSets = [],
                dummyProduct = {
                    isdummy: true,
                    supplier: {
                        name: trns.supplier
                    },
                    description: '',
                    supplierNo: trns.supplierNo,
                    manufacturer: trns.manufacturer,
                    manufacturerNo: trns.manufacturerNo,
                    vcatalog: {
                        name: trns.catalog
                    },
                    eClass: {
                        value: trns.eClass
                    },
                    ean: trns.ean,
                    basketLink: {
                        price: {
                            taxrate: trns.taxrate,
                            basePrice: trns.price
                        }
                    },
                    productCategory: trns.productCategory
                };


            for(idx = 0; idx < allAttributeSetNames.length; idx++) {
                attributeList = [];

                for(attrIdx = 0; attrIdx < allAttributeSetAttributeNames[idx].length; attrIdx++) {
                    attributeList.push({
                        name: (copyNames ? allAttributeSetAttributeNames[idx][attrIdx] : ''),
                        value: ''
                    });
                }
                attributeSets.push({
                    label: allAttributeSetNames[idx],
                    attributes: attributeList
                });
            }

            dummyProduct.attributeSets = attributeSets;

            return dummyProduct;
        };

        this.clearAttributeSetProperties = function(scope) {
            if(scope) {
                scope.allAttributeSetNames = [];
                scope.allAttributeSetAttributeNames = [];
            }
        };

        this.unifyAttributeSets = function(scope, products, createCopy) {
            var prodIdx, attrSetIdx,
                currentAttrSetIdx,
                attrIdx,
                product, singleAttrSet,
                currentProductAttributeSetNames = [],
                currentProductAttributeSetIndexes = [],
                attrSetName,
                newAttributeSets = [],
                allAttributeSetNames = [],
                attributeNames,
                attrName,
                allAttributeSetAttributeNames = [];

            if(!scope || !products) {
                return [];
            }

            scope.allAttributeSetNames = [];
            scope.allAttributeSetAttributeNames = [];

            //Backend-info:
            //AttributeProperty: name, value
            //ProductAttributeSetDTO: label, List<AttributeProperty> attributes
            for(prodIdx = 0; prodIdx < products.length; prodIdx++) {
                product = products[prodIdx];
                scope.hasProductCategory = scope.hasProductCategory || product.productCategory;
                if(product && product.attributeSets) {
                    for(attrSetIdx = 0; attrSetIdx < product.attributeSets.length; attrSetIdx++) {
                        singleAttrSet = product.attributeSets[attrSetIdx];
                        if(singleAttrSet && singleAttrSet.label) {
                            currentAttrSetIdx = allAttributeSetNames.indexOf(singleAttrSet.label);
                            attributeNames = [];

                            if(currentAttrSetIdx < 0) {
                                allAttributeSetNames.push(singleAttrSet.label);
                                if(singleAttrSet.attributes) {
                                    for(attrIdx = 0; attrIdx < singleAttrSet.attributes.length; attrIdx++) {
                                        attributeNames.push(singleAttrSet.attributes[attrIdx].name);
                                    }
                                }
                                allAttributeSetAttributeNames.push(attributeNames);
                            }
                            else {
                                attributeNames = allAttributeSetAttributeNames[currentAttrSetIdx];
                                if(singleAttrSet.attributes) {
                                    for(attrIdx = 0; attrIdx < singleAttrSet.attributes.length; attrIdx++) {
                                        attrName = singleAttrSet.attributes[attrIdx].name;
                                        if(attrName) {
                                            if(attributeNames.indexOf(attrName) < 0) {
                                                attributeNames.push(attrName);
                                            }
                                        }
                                    }
                                    allAttributeSetAttributeNames[currentAttrSetIdx] = attributeNames;
                                }
                            }
                        }
                    }
                }
            }
            //Second pass.
            for(prodIdx = 0; prodIdx < products.length; prodIdx++) {
                product = products[prodIdx];
                currentProductAttributeSetNames = [];
                currentProductAttributeSetIndexes = [];

                if(product && product.attributeSets) {
                    for(attrSetIdx = 0; attrSetIdx < product.attributeSets.length; attrSetIdx++) {
                        singleAttrSet = product.attributeSets[attrSetIdx];
                        if(singleAttrSet && singleAttrSet.label) {
                            if(currentProductAttributeSetNames.indexOf(singleAttrSet.label) < 0) {
                                currentProductAttributeSetNames.push(singleAttrSet.label);
                                currentProductAttributeSetIndexes.push(attrSetIdx);
                            }
                        }
                    }
                }

                newAttributeSets = [];

                for(attrSetIdx = 0; attrSetIdx < allAttributeSetNames.length; attrSetIdx++) {
                    attrSetName = allAttributeSetNames[attrSetIdx];
                    currentAttrSetIdx = currentProductAttributeSetNames.indexOf(attrSetName);
                    if(currentAttrSetIdx < 0) {
                        var attrNames = allAttributeSetAttributeNames[attrSetIdx];
                        //Add it.
                        newAttributeSets.push({
                            label: attrSetName,
                            attributes: createDummyAttributes(attrNames)
                        });
                    }
                    else {
                        //copy old
                        currentAttrSetIdx = currentProductAttributeSetIndexes[currentAttrSetIdx];
                        var newAttributes = unifyAttributes(product.attributeSets[currentAttrSetIdx].attributes,
                            allAttributeSetAttributeNames[attrSetIdx]);

                        newAttributeSets.push({
                            label: product.attributeSets[currentAttrSetIdx].label,
                            attributes: newAttributes
                        });
                    }
                }

                products[prodIdx].attributeSets = newAttributeSets;
            }

            scope.allAttributeSetNames = allAttributeSetNames;
            scope.allAttributeSetAttributeNames = allAttributeSetAttributeNames;

            return products;
        };
    })
    .controller('ProductComparisonCtrl', ['$scope', 'dataGen', '$mdToast', 'AddToBasketService', 'ProductComparisonHelperService', '$timeout', 'ToastService', 'ToolbarService', 'TranslationService','ixaProductComparison',
        function($scope, dataGen, $mdToast, AddToBasketService, ProductComparisonHelperService, $timeout, ToastService, ToolbarService, TranslationService, ixaProductComparison) {
            $scope.dataVersion = 1;
            var defaultHeightOfDescription = 72;
            $scope.expandListNew = {
                description: false,
                general: true,
                other: false
            };

            $scope.allAttributeSetNames = [];
            $scope.allAttributeSetAttributeNames = [];
            $scope.productsWithDummy = {};
            $scope.useAnimateIf = false;
            var self = this;

            $scope.setUpAttributes = function() {
                $scope.attributes = ProductComparisonHelperService.collectAttributeNames($scope.data.products);
            };

            $scope.onSuccessDataRequest = function() {
                $scope.setUpAttributes();

                if(impactX.isDefined($scope, 'data.products')) {
                    $scope.data.products = ProductComparisonHelperService.unifyAttributeSets($scope, $scope.data.products, false);
                    $scope.productsWithDummy.data = $scope.getProductsWithDummy();

                    $scope.productList = $scope.productsWithDummy.data;
                    $timeout(function() {
                        var divsDescription = document.getElementsByClassName('comparison-cardstyle-description');
                        if (!divsDescription || divsDescription.length === 0)
                        {
                            var divWatcher = $scope.$watch(function () {
                                    return document.getElementsByClassName('comparison-cardstyle-description').length
                                 }, function (newValue, oldValue) {
                                if (newValue > 0)
                                {
                                    $scope.updateDescriptionDivs(document.getElementsByClassName('comparison-cardstyle-description'));
                                    divWatcher();
                                }
                            });
                        }
                        else
                        {
                            $scope.updateDescriptionDivs(divsDescription);
                        }
                    });
                }
                ToolbarService.setButtons([
                    {
                        label: TranslationService.get('delete'),
                        action: $scope.deleteAllProducts,
                        condition: $scope.canDeleteAllProducts,
                        type: 'dialogaction'
                    }]);
                $scope.dataVersion += 1;
            };

            $scope.updateDescriptionDivs = function(divsDescription) {
                for (var i = 0; i < divsDescription.length; i++) {
                    if (divsDescription[i].offsetHeight > defaultHeightOfDescription)
                    {
                        $scope.productList[i].longDescription = true;
                    }
                }
                self.handleDivHeightDescription();
                self.handleDivHeightHeader();
                $scope.show = true;
            };

            $scope.getPageData = function() {
                dataGen.getData($scope, {}, "/product/comparison/list").then(function() {
                    $scope.onSuccessDataRequest();
                });
            };

            $scope.getProductsWithDummy = function() {
                var idx, result = [];

                if($scope.data.products && $scope.data.products.length > 0) {
                    result.push(ProductComparisonHelperService.createDummyProduct(
                        $scope.trns,
                        $scope.allAttributeSetNames,
                        $scope.allAttributeSetAttributeNames,
                        true
                    ));

                    for(idx = 0; idx < $scope.data.products.length; idx++) {
                        result.push($scope.data.products[idx]);
                    }
                }
                return result;
            };

            $scope.toggleGeneralList = function() {
                $scope.expandListNew.general = !$scope.expandListNew.general;
            };

            $scope.toggleExtraList = function() {
                $scope.expandListNew.other = !$scope.expandListNew.other;
            };
            $scope.toggleDescriptionList = function() {

                $scope.expandListNew.description = !$scope.expandListNew.description;
                self.handleDivHeightDescription();
            };

            this.handleDivHeightHeader = function () {
                var divsHeader = document.getElementsByClassName('comparison-cardstyle-header');
                var maxHeight = 0;
                for (var l = 0; l < divsHeader.length; l++) {
                    if (maxHeight < divsHeader[l].offsetHeight) {
                        maxHeight = divsHeader[l].offsetHeight;
                    }
                }
                var maxHeightToSet = maxHeight + "px";
                for (var j = 0; j < divsHeader.length; j++) {
                    divsHeader[j].style.height = maxHeightToSet;
                }
            };

            this.handleDivHeightDescription = function () {
                var divs = document.getElementsByClassName('comparison-cardstyle-description');
                if ($scope.expandListNew.description) {
                    for (var k = 0; k < divs.length; k++) {
                        divs[k].style.height = null;
                    }
                    var maxHeight = defaultHeightOfDescription;
                    for (var l = 0; l < divs.length; l++) {
                        if (maxHeight < divs[l].offsetHeight) {
                            maxHeight = divs[l].offsetHeight;
                        }
                    }
                    var maxHeightToSet = maxHeight + "px";
                    for (var j = 0; j < divs.length; j++) {
                        divs[j].style.height = maxHeightToSet;
                    }
                }
                else {
                    for (var i = 0; i < divs.length; i++) {
                        divs[i].style.height = defaultHeightOfDescription + 'px';
                    }
                }
            };

            $scope.getPageData();

            $scope.deleteSingleProduct = function(product, index) {
                if (product && product.id){
                    var dataObj = {
                        product: product
                    };
                    var temp = {};
                    dataGen.postAsForm(temp, dataObj, "/product/comparison/delete").then(function() {
                        ixaProductComparison.updateProductComparisonCount();
                        ToastService.openStandardToast(temp.trns.remove_success);
                        $scope.productList.splice(index, 1);
                        if ($scope.productList.length === 1)
                        {
                            $scope.getPageData();
                        }
                    });
                }
            };

            $scope.deleteAllProducts = function() {
                return dataGen.postAsForm($scope, {}, "/product/comparison/delete/all").then(function() {
                    ixaProductComparison.updateProductComparisonCount();
                    ToastService.openStandardToast($scope.trns.remove_success);
                    $scope.onSuccessDataRequest();
                });
            };

            $scope.canDeleteAllProducts = function() {
                return $scope.productList.length > 0;
            };

            $scope.addToBasket = AddToBasketService.addToBasket;
            $scope.addExternalProductToBasket = AddToBasketService.addExternalProductToBasket;
        }
    ]);